<template>
    <div id='notfound'>
        <h1 v-if='diconame' style='text-align:center'>404 : Dico {{diconame}} Not Found</h1>
        <h1 v-else              style='text-align:center' >404 : Not Found</h1>
        <p>Oops</p>
        <router-link to='/accueil'>Accueil</router-link>
    </div>
</template>

<script>
    export default {
        name: "NotFound",
        props: {
            diconame : {
                type:String
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
